import "brace/ext/language_tools";
import "brace/mode/mysql";
import "brace/theme/dracula";
import AceEditor from "react-ace";
import { useTranslation } from "react-i18next";
import { Button, Input } from "semantic-ui-react";

import "modules/DMSv3/CustomQueries/components/QueryEditor/QueryEditor.scss";

type QueryEditorProps = {
  name: string;
  statement: string;
  isRunDisabled: boolean;
  isLoading: boolean;
  onNameChange: (value: string) => void;
  onStatementChange: (value: string) => void;
  onRunQuery: () => void;
};

export const QueryEditor = ({ name, statement, isRunDisabled, isLoading, onNameChange, onStatementChange, onRunQuery }: QueryEditorProps) => {
  const { t } = useTranslation();

  return (
    <div className="QueryEditor">
      <Input
        fluid
        className="query-name-input"
        placeholder={t("v8_enter_query_name", "Enter query name")}
        value={name}
        onChange={(_, { value }) => onNameChange(value)}
      />

      <div className="editor-card">
        <AceEditor
          mode="mysql"
          name="custom-query-editor"
          theme="dracula"
          width="100%"
          height="35vh"
          wrapEnabled
          fontSize={16}
          showGutter={false}
          showPrintMargin={false}
          highlightActiveLine={false}
          setOptions={{ enableBasicAutocompletion: true, enableLiveAutocompletion: true, useSoftTabs: true }}
          value={statement}
          onChange={onStatementChange}
          onLoad={editor => editor.renderer.setPadding(12)}
        />

        <div className="run-button-wrapper">
          <Button fluid primary disabled={isRunDisabled || isLoading} loading={isLoading} onClick={onRunQuery}>
            {t("v8_run_query", "Run Query")}
          </Button>
        </div>
      </div>
    </div>
  );
};
